<template>
  <div
    class="card-main"
    @click="onClick"
    @mouseover="focusOn"
    @mouseleave="focusOut"
  >
    <div class="focus-ring" v-show="isfocusOn && mouseActivated"></div>
    <div class="thumbnail-area">
      <img class="cover-img" v-lazy="cardData.imgUrl" />
      <img src="@/assets/rock-img.png" class="lock-img" v-show="!leaguePassCheck" alt="lock-img">
      <img src="@/assets/badge-live@2x.png" class="live-badge" alt="live-badge-img">
    </div>
    <div v-if="cardData.gameDesc" class="card-text">
      <p class="team-name singleline" :class="{ doubleline: textLine2 == false }">
        {{ textLine1 }}
      </p>
      <p v-if="textLine2" class="team-name singleline">{{ textLine2 }}</p>
      <p class="desc singleline">
        {{ textLine3 }}
      </p>
      <div class="info2">
        <span class="sticker" v-if="cardData.isMonopoly">독점</span>
        <span class="sticker" v-if="cardData.isFree">무료</span>
        <!-- <span class="sticker" v-if="cardData.isBypass">현지</span> -->
        <span class="sticker" v-if="language">{{ language }}</span>

        <span v-if="contentType == 6" class="date">{{
          timeString(cardData.duration)
        }}</span>
        <span v-else class="date">{{
          dateFormat(cardData.gameDesc.beginDate)
        }}</span>
      </div>
    </div>
    <div v-else class="card-text">
      <p class="title doubleline">{{ cardData.title }}</p>

      <span v-if="contentType == 6" class="desc">{{
        timeString(cardData.duration)
      }}</span>
      <div v-else class="desc singleline">
        {{ cardData.leagueName }} | {{ dateFormat(cardData.beginDate) }}
      </div>
      <div>
        <span class="sticker" v-if="cardData.vtype">{{ cardData.vtype }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { leaguePassPlayCheck, contentsPermissionCheck } from "@/utils/common"

export default {
  data() {
    return {
      isActiveVue: true,
      isfocusOn: false,
    };
  },
  props: ["cardData", "isFocusedLine", "contentType"],
  computed: {
    language() {
      let text = false;
      switch (this.cardData.language) {
        case 1:
          text = "외국어";
          break;
        case 2:
          text = "한국어";
          break;
        case 3:
          text = "영어";
          break;
      }
      return text;
    },
    gameType() {
      let type = 0;
      switch (this.cardData.gameDesc.typeId) {
        case 1: // 축구
        case 3: // 농구
        case 4: // 배구
        case 7: // 야구
          type = "A";
          break;
        case 2: // 종합격투기
          type = "B";
          break;
        case 6: // 골프
          type = "C";
          break;
        case 5: // 테니스
        case 8: // 일반
          type = "D";
          break;
        default:
          type = "D";
      }
      return type;
    },
    textLine1() {
      let text = "";
      if (this.cardData.gameDesc.type == 1) {
        // 종합격투기, 골프
        if (this.gameType == "B" || this.gameType == "C") {
          text = this.cardData.gameDesc.seasonName;
          // 그외
        } else {
          text = this.cardData.gameDesc.homeName;
        }
        // 이벤트
      } else if (this.cardData.gameDesc.type == 2) {
        text = this.cardData.title;
        // 프로그램
      } else {
        text = this.cardData.title;
      }
      return text;
    },
    textLine2() {
      let text = false;
      // 경기
      if (this.cardData.gameDesc.type == 1) {
        // 종합격투기, 골프
        if (this.gameType !== "B" || this.gameType !== "C") {
          text = this.cardData.gameDesc.awayName;
        }
      }
      return text;
    },
    textLine3() {
      let text = "";
      if (this.cardData.gameDesc.type == 1) {
        // 종합격투기
        if (this.gameType == "B") {
          text = this.cardData.gameDesc.leagueName;
          // 그외
        } else if (this.gameType == "D") {
          text =
            this.cardData.gameDesc.leagueName +
            " | " +
            this.cardData.gameDesc.seasonName +
            " | " +
            this.cardData.gameDesc.roundName;
          // 축구, 농구, 배구, 야구, 골프
        } else {
          text =
            this.cardData.gameDesc.leagueName +
            " | " +
            this.cardData.gameDesc.roundName;
        }
        // 이벤트
      } else if (this.cardData.gameDesc.type == 2) {
        text = 
          this.cardData.gameDesc.leagueName
      }
      return text;
    },
    mouseActivated() {
      return this.$store.getters.mouseActivated;
    },
    leaguePassCheck() {
      // 리그 전용 이용권 시청 권한 확인
      let flag = true
      let voucher = this.$store.getters.userSubscription;

      if (this.cardData.isFree) {
        return flag
      }
      
      if(voucher.typeId === 2) {
        flag = leaguePassPlayCheck(this.cardData.gameDesc, voucher.serviceTypeScope)
      }

      return flag
    },
  },
  methods: {
    onClick() {
      if (this.isfocusOn) {
        this.clickCard();
      }
    },
    async clickCard() {
      const checkParams = {
        type: this.cardData.type,
        id: this.cardData.id
      }

      // 리그 전용 이용권 시청 권한 확인
      const checkValue = await contentsPermissionCheck(checkParams)

      if (checkValue) {
        this.focusOut();
        this.$router.push({
          name: "player",
          params: {
            vodId: this.cardData.id,
            contentType: this.cardData.type,
          },
        });
      }
    },
    focusOn() {
      if (this.isFocusedLine) {
        this.isfocusOn = true;
      }
    },
    focusOut() {
      this.isfocusOn = false;
    },
    dateFormat(dateStr) {
      let str;
      str = dateStr.replace(/-/gi, ".");
      if (this.cardData.type == "live") {
        str = str.substr(5, 11);
      } else {
        str = str.substr(0, 10);
      }
      return str;
    },
    timeString(time) {
      return new Date(time).toISOString().substr(11, 8);
    },
  },
  // deactivated() {
  //   this.focusOut()
  // },
};
</script>

<style scoped>
.card-main {
  position: relative;
  display: inline-block;
  margin-right: 20px;
  height: 410px;
  z-index: 2;
}

.focus-ring {
  position: absolute;
  left: -5px;
  top: -4px;
  height: 410px;
  width: 444px;
  border: solid 4px #eeeeee;
  z-index: 5;
}

.thumbnail-area {
  width: 444px;
  height: 250px;
  position: relative;
  background-color: #2b2b2b;
  overflow: hidden;
}

.cover-img {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}

.lock-img {
  width: 36px;
  height: 36px;
  position: absolute;
  top: 12px;
  right: 12px;
}

.live-badge {
  width: 72px;
  height: 32px;
  position: absolute;
  right: 12px;
  bottom: 12px;
}
.card-text {
  height: 132px;
  padding: 12px 10px;
  display: inline-block;
  position: absolute;
  top: 250px;
  left: 0;
}
.title {
  font-size: 28px;
  line-height: 36px;
  height: 72px;
  color: #a0a0a0;
}
.team-name {
  width: 434px;
  font-size: 28px;
  line-height: 36px;
  color: #a0a0a0;
}
.team-name.doubleline {
  height: 72px;
}
.desc {
  width: 434px;
  margin-top: 6px;
  margin-bottom: 2px;
  font-size: 20px;
  line-height: 30px;
  color: #707070;
}
.date {
  font-size: 20px;
  color: #a0a0a0;
}
.sticker {
  width: 65px;
  height: 28px;
  margin-right: 8px;
  padding: 0 8px;
  font-size: 18px;
  background-color: #2c2c2c;
  text-align: center;
  color: #9c9c9c;
}
.info2 {
  /* position: absolute; */
  /* left: 10px; */
  /* top: 123px; */
  width: 420px;
}

@media all and (min-width:0px) and (max-width:1280px){
  .card-main {
    position: relative;
    display: inline-block;
    margin-right: 16px;
    height: 316px;
    z-index: 2;
  }

  .focus-ring {
    position: absolute;
    left: -5px;
    top: -4px;
    height: 324px;
    width: 308px;
    border: solid 4px #eeeeee;
    z-index: 5;
  }

  .thumbnail-area {
    width: 300px;
    height: 168px;
    background-color: #2b2b2b;
  }

  .lock-img {
    width: 24px;
    height: 24px;
    position: absolute;
    top: 10px;
    right: 10px;
  }

  .live-badge {
    width: 51px;
    height: 24px;
    right: 10px;
    bottom: 10px;
  }

  .card-text {
    width: 300px;
    height: 148px;
    padding: 16px 4px;
    display: inline-block;
    position: absolute;
    top: 168px;
    left: 0;
  }

  .title {
    font-size: 20px;
    line-height: 28px;
    height: 56px;
    color: #ffffff;
  }

  .team-name {
    width: 100%;
    font-size: 20px;
    line-height: 28px;
    color: #ffffff;
  }

  .team-name.doubleline {
    height: 56px;
  }

  .desc {
    width: 100%;
    margin-top: 16px;
    margin-bottom: 8px;
    font-size: 18px;
    line-height: 1;
    color: #888888;
  }

  .info2 {
    width: 100%;
  }
  .sticker {
    display: inline-block;
    width: auto;
    height: 28px;
    margin-right: 6px;
    padding: 0 8px;
    font-size: 16px;
    line-height: 28px;
    background-color: #2c2c2c;
    text-align: center;
    color: #9c9c9c;
  }
  .date {
    font-size: 16px;
    color: #888888;
  }
}
</style>